import React from 'react'

const Manual_configuracion_kiosko_app = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Configuración de Kiosco | APP
        </h2>
        <iframe
          src="https://scribehow.com/embed/Configuracion_de_Kiosco_or_APP___DWzWPRZTeS2ENjwaYoiRA?as=scrollable"
          className="scribe-iframe-general-75"
          width="100%"
          height="7000"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_configuracion_kiosko_app
